import { API_URL_WEBINAR } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getWebinar = (uuid: string) =>
  apiInstance({
    url: API_URL_WEBINAR + uuid,
  });

export default getWebinar;
